<mat-form-field [ngClass]="isFilter ? 'isFilter' : null" floatLabel="never">
  <input type="text" matInput [formControl]="control" [matAutocomplete]="auto"
    [placeholder]="isFilter ? 'Filtre' : null">
  <mat-label *ngIf="!isFilter">{{ label | translate }}</mat-label>

  <mat-autocomplete #auto="matAutocomplete"
    (optionSelected)="onChange(); isFilter ? selectedOptionForFilter.emit() : null">
    <mat-option *ngFor="let item of filteredList | async" [value]="item" [title]="item">
      {{ item }}
    </mat-option>
  </mat-autocomplete>
  <mat-error>{{ errorMsg | translate }}</mat-error>
</mat-form-field>